import { RSAA } from 'redux-api-middleware';
import { CASE_DATA_KEY } from '../../utils/constants';

export const FETCH_CONTENT = 'FETCH_CONTENT';
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS';
export const FETCH_CONTENT_FAILED = 'FETCH_CONTENT_FAILED';
export const fetchContent = (contentPath = './business-details.content.json') => ({
  [RSAA]: {
    endpoint: contentPath,
    method: 'GET',
    types: [
      {
        type: FETCH_CONTENT,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_CONTENT_SUCCESS,
        meta: (_action, state) => ({
          loading: state && state.cases && state.cases.get(CASE_DATA_KEY)
        })
      },
      {
        type: FETCH_CONTENT_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});
